export const paymentDetailsFeatureName = 'paymentDetails';
